export default __webpack_public_path__ + "static/media/launchpad-zero-state.9b822538.png";